"use client";

import { AnimatedSection } from "./motion";

export function DemoSection() {
  return (
    <AnimatedSection id="chat" className="container py-12 md:py-24 lg:py-32">
      <div className="mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center">
        <span className="inline-flex items-center rounded-full bg-indigo-50 px-4 py-1 text-xs font-semibold text-indigo-600 ring-1 ring-inset ring-indigo-200">
          Live Demo
        </span>
        <h2 className="font-heading text-3xl leading-[1.1] sm:text-3xl md:text-6xl">
          Test our chatbot assistant
        </h2>
        <p className="max-w-[85%] leading-relaxed text-muted-foreground sm:text-lg">
          Ask any question about BotByte AI to our chatbot and see how it responds. Powered by
          leading AI models including GPT, Claude & Gemini. You can also try the chatbot button at
          the bottom right.
        </p>
        <div className="min-w-[85%] min-h-[15rem] text-left items-left pt-6">
          <iframe
            src="/embed/clxbh6fxz0007eb78z13ajloc/window?chatbox=false"
            className="overflow-hidden border border-slate-200 rounded-2xl shadow-xl shadow-slate-200/50 w-full h-[65vh]"
            allowFullScreen
            allow="clipboard-read; clipboard-write"
            loading="lazy"
            tabIndex={-1}
          />
        </div>
      </div>
    </AnimatedSection>
  );
}
